import React, { Component } from 'react'
import Paper from 'material-ui/Paper'
import IconButton from 'material-ui/IconButton'
import Dialog from 'material-ui/Dialog'
import Clear from 'material-ui/svg-icons/content/clear'
import FlatButton from 'material-ui/FlatButton'
import { FormattedMessage } from 'react-intl'
import StripeCheckout from 'react-stripe-checkout'
import PlanHeading from './PlanHeading'
import PlanFeatures from './PlanFeatures'
import images from '../../../config/images'
import { getToken, isAccountFree, isAccountPremium, isSentry } from '../../../lib'
import { ALertHeaderText } from '../../../components/Seminars/SeminarActions/styles'
import config from '../../../config/config'
import Loader from 'react-loader'

const UpGradeDegradeComplete = props =>
  <div>
    <div className="flex justify-center items-center mb4">
      <ALertHeaderText>プラン変更に成功しました。</ALertHeaderText>
    </div>
    <div className="flex justify-center mb4">
      <img src={images.successImage} alt="congrats"/>
    </div>
    <div className="flex justify-center">
      <FlatButton
        label="進む"
        hoverColor="#1e8257"
        backgroundColor="#29B87A"
        labelStyle={{color: '#FFFFFF'}}
        onTouchTap={props.handleClose}
      />
    </div>
  </div>

class Plans extends Component {
  state = {
    open: false,
    upgrade: false,
    error: false,
    plan: '',
    priceToPay: 0,
    loading: false
  }

  async onToken (token, plan) {
    this.setState({loading: true})
    // 4242 4242 4242 4242
    // 5555 5555 5555 4444

    try {
      var endpoint = 'stripe_create_subscription'
      var method = 'POST'
      let plan_id
      if (plan === 'update_card') {
        endpoint = 'stripe_update_card'
        method = 'PUT'
      } else if (plan === 'premium') {
        plan_id = config.PREMIUM
      }
      const payload = {
        stripeEmail: token.email,
        stripeToken: token.id,
        new_plan_id: plan_id,
        new_plan_name: plan
      }
      let response = await fetch(`${config.URI}/api/v1/${endpoint}`, {
        method: method,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Authenticity-Token': getToken()
        },
        body: JSON.stringify(payload)
      })
      let res = await response.json()
      // console.log(res);
      if (res.errors && Object.keys(res.errors).length >= 1) {
        return this.setState({error: true, upgrade: false})
      }
      this.setState({upgrade: true})
      if (plan === 'update_card') {
        alert('カード情報の更新に成功しました。')
      }

    } catch (error) {
      console.error(error)
      isSentry(error)
    }

    this.setState({loading: false})
  }

  handleOpen = (plan, price) => {
    let priceToPay = 0
    if (!isAccountFree(plan)) {
      priceToPay = parseInt(price.replace(',', ''), 10)
    } else {
      priceToPay = 0
    }
    this.setState({open: true, plan, priceToPay})
  }

  handleClose = () => {
    const token = getToken()
    if (!this.state.error) {
      this.props.returnUserIfUserExists(token)
      this.setState({open: false, upgrade: false})
    } else {
      this.setState({open: false, upgrade: false, error: false})
    }
  }

  closeModal = () => this.setState({open: false})

  handleUpgrade = plan => {
    const token = getToken()
    this.props.changePlan(token, plan)
    this.setState({upgrade: true})
  }

  render () {
    let {
      userPlan,
      contract,
      starterPrice,
      premiumPrice,
      location
    } = this.props
    // userPlan = 'premium';
    // console.log("userPlan", userPlan)
    return (
      <Paper className="flex" style={{width: '50vw', height: '65vh', margin: '0px auto'}}>
        {this.state.loading && <Loader loaded={false} lines={13} length={20} width={10} radius={30}
                                       corners={1} rotate={0} direction={1} color="#000" speed={1}
                                       trail={60} shadow={false} hwaccel={false} className="spinner"
                                       zIndex={2e9} top="50%" left="50%" scale={1.00}
                                       loadedClassName="loadedContent"/>}
        <div
          className="h-100 w-50"
          style={{borderRight: '1px solid #d9d9d9'}}>
          <div style={{height: '1vh', backgroundColor: '#4688F1'}}/>
          <div
            style={{height: '64vh'}}
            className="flex flex-column justify-between">
            <div>
              <PlanHeading contract={contract} plan="無料"/>
              <PlanFeatures location={location} plan="free"/>
            </div>
            <div className="flex justify-center items-center mb3">
              <FlatButton
                onTouchTap={e => {
                  if (isAccountFree(userPlan)) {
                    return
                  }
                  this.handleOpen('free', 0)
                }
                }
                disabled={isAccountFree(userPlan)}
                label={
                  isAccountFree(userPlan)
                    ? <FormattedMessage id="plan.currentPlan"/>
                    : <FormattedMessage id="plan.backToFree"/>
                }
                hoverColor={isAccountFree(userPlan) ? '#c9c5c5' : '#1d8e5d'}
                backgroundColor={
                  isAccountFree(userPlan) ? '#F6F6F6' : '#29B87A'
                }
                labelStyle={{
                  color: isAccountFree(userPlan) ? '#AFB8C4' : '#FFFFFF'
                }}
              />
            </div>
          </div>
        </div>
        <div className="h-100 w-50">
          <div style={{height: '1vh', backgroundColor: '#C347E1'}}/>
          <div
            style={{height: '64vh'}}
            className="flex flex-column justify-between">
            <div>
              <PlanHeading
                price={'premiumPrice'}
                contract={contract}
                plan="プレミアム"
              />
              <PlanFeatures location={location} plan="premium"/>
            </div>
            <div className="flex justify-center items-center mb3">
              <FlatButton
                onTouchTap={e => {
                  if (isAccountPremium(userPlan)) {
                    return
                  }
                  this.handleOpen(
                    `premium`,
                    premiumPrice
                  )
                }
                }
                disabled={isAccountPremium(userPlan)}
                label={
                  isAccountPremium(userPlan)
                    ? <FormattedMessage id="plan.currentPlan"/>
                    : <FormattedMessage id="plan.upgrade"/>
                }
                hoverColor={isAccountPremium(userPlan) ? '#c9c5c5' : '#1d8e5d'}
                backgroundColor={
                  isAccountPremium(userPlan) ? '#F6F6F6' : '#29B87A'
                }
                labelStyle={{
                  color: isAccountPremium(userPlan) ? '#AFB8C4' : '#FFFFFF'
                }}
              />
            </div>
          </div>
        </div>
        <Dialog
          modal
          contentStyle={{width: '40vw'}}
          open={this.state.open}
          onRequestClose={this.handleClose}>
          {this.state.error
            ? <div>
              <div className="flex justify-between items-center mb3">
                <ALertHeaderText>
                  <FormattedMessage id="plan.upgradeFailed"/>
                </ALertHeaderText>
                <div>
                  <IconButton
                    onTouchTap={this.closeModal}
                    iconStyle={{fill: '#afb8c5'}}>
                    <Clear/>
                  </IconButton>
                </div>
              </div>
              <ALertHeaderText className="mb3">
                <FormattedMessage id="plan.paymentFailed"/>
              </ALertHeaderText>
              <div className="flex justify-end">
                <FlatButton
                  label={<FormattedMessage id="plan.close"/>}
                  labelStyle={{color: '#AFB8C4'}}
                  onTouchTap={this.handleClose}
                />
              </div>
            </div>
            : this.props.planerror
              ? <div className="flex justify-between items-center mb3">
                <ALertHeaderText>
                  {'ストリップ購読が見つかりません'}
                </ALertHeaderText>
              </div>
              : this.props.isUpdatingPlan
                ? <div
                  className="flex justify-center items-center"
                  style={{height: 300}}>
                  Updating plan...
                </div>
                : this.state.upgrade
                  ? <UpGradeDegradeComplete handleClose={this.handleClose}/>
                  : <div>
                    <div className="flex justify-between items-center mb3">
                      <ALertHeaderText>
                        {'プランの変更'}
                      </ALertHeaderText>
                      <div>
                        <IconButton
                          onTouchTap={this.closeModal}
                          iconStyle={{fill: '#afb8c5'}}>
                          <Clear/>
                        </IconButton>
                      </div>
                    </div>
                    {this.state.plan === 'free'
                      ? <div
                        style={{color: '#F01631', fontSize: 20}}
                        className="mb3">
                        <FormattedMessage id="plan.noRefund"/>
                      </div>
                      : ''}
                    <ALertHeaderText className="mb3">
                      <FormattedMessage id="plan.sure"/>
                      {this.state.plan !== 'free'
                        ? <span>
                            <FormattedMessage id="plan.upgradeTo"/>
                          {'プレミアムへのプラン変更を行います。変更時に¥2,000がかかります。月額費用は日割りで請求が行われます。'}
                          </span>
                        : null}
                    </ALertHeaderText>
                    {this.state.plan === 'free'
                      ? <ALertHeaderText className="mb3">
                        <FormattedMessage id="plan.warning"/>
                      </ALertHeaderText>
                      : ''}
                    <div className="flex justify-end">
                      <div className="w4">
                        <FlatButton
                          label={
                            <FormattedMessage id="loggedInNavigation.cancel"/>
                          }
                          fullWidth
                          labelStyle={{color: '#AFB8C4'}}
                          onTouchTap={this.closeModal}
                        />
                      </div>
                      <div className="ml2 w6">
                        {this.state.plan === 'free'
                          ? <FlatButton
                            label={<FormattedMessage id="plan.backToFree"/>}
                            hoverColor="#1e8257"
                            fullWidth
                            backgroundColor="#29B87A"
                            labelStyle={{color: '#FFFFFF'}}
                            onTouchTap={e => this.handleUpgrade(this.state.plan)}
                          />
                          : this.props.stripeAccount
                            ? <FlatButton
                              label={'プレミアムへ変更'}
                              fullWidth
                              style={{padding: 0}}
                              hoverColor="#1e8257"
                              backgroundColor="#29B87A"
                              labelStyle={{color: '#FFFFFF'}}
                              onTouchTap={e => this.handleUpgrade(this.state.plan)}
                            />
                            : <StripeCheckout
                              image={config.ADMIN_URL + '/workshop_icon.png'}
                              name="Anet Co.,Ltd."
                              panelLabel={'¥2,000を支払う'}
                              description=""
                              email={this.props.email}
                              allowRememberMe={false}
                              token={token =>
                                this.onToken(token, this.state.plan)}
                              stripeKey={config.STRIPE_KEY}
                            />}
                      </div>
                    </div>
                  </div>}
        </Dialog>
      </Paper>
    )
  }
}

export default Plans



// WEBPACK FOOTER //
// ./src/routes/ManagePlans/Plans/Plans.js